/**
 * Nome de exibicao de uma instancia (inbox).
 *
 * O nome gravado carrega marcacoes internas que nao interessam a quem atende:
 * os prefixos de canal, o marcador `[ARQUIVADA]` e o sufixo ` · <hash>`, que
 * so existe para desambiguar duas conexoes com o mesmo apelido. A mesma conexao precisa
 * aparecer com o MESMO texto no card da lista, na busca rapida e no historico
 * de conversas do contato -- por isso a regra vive aqui, e nao copiada em cada
 * tela.
 *
 * @param {string} name Nome cru da inbox.
 * @returns {string} Nome limpo, pronto para exibicao.
 */
export const inboxDisplayName = name =>
  String(name || '')
    .replace(/^\s*\[ARQUIVADA\]\s*/i, '')
    .replace(/^\s*arquivada\s*[-:]\s*/i, '')
    .replace(/^\s*(?:instagram|messenger)\s*[·|-]\s*/i, '')
    .replace(/^\s*(?:instagram|messenger)\s*$/i, '')
    .replace(/\s·\s[a-f0-9]+$/i, '');

export default inboxDisplayName;
